import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useMeQuery } from "../../../auth/api/authApi";

export default function PaymentSuccess() {
  const { paymentId } = useParams<{ paymentId: string }>();
  const { refetch } = useMeQuery();

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="max-w-xl mx-auto p-6 text-center space-y-6">
      <CheckCircle2 className="w-16 h-16 text-green-600 mx-auto" />
      <h1 className="text-2xl font-bold">Payment Successful!</h1>
      <p className="text-gray-500">
        Your payment has been recorded successfully.
      </p>
      <Link
        to={`/receipt/${paymentId}`}
        className="bg-black text-white px-6 py-3 rounded-xl inline-block font-semibold"
      >
        View Receipt
      </Link>
      <Link
        to="/my-invoices"
        className="text-blue-600 hover:underline block mt-2"
      >
        Back to Invoices
      </Link>
    </div>
  );
}
